import { connect, no_render } from 'core';
import * as selectors from 'selectors';
import ProfileContent from 'comp/middle/settings_content';
import { cache } from 'utils';

const mapToProps = state => {
  const selected_settings_item = state.ui.selected_settings_item;
  if (!selected_settings_item) {
    return no_render;
  }
  return {
    jumping: state.ui.jump_to_conv,
    account: {
      user: state.user,
      status: state.fetch.user_update_user || cache.empty_obj,
      avatar_status: state.fetch.user_upload_avatar || cache.empty_obj,
      upload_avatar: state.uploader.user_avatar
    },
    support: { user: state.user },
    devices: {
      sessions: selectors.objToArray(state, 'auth', 'list', 'sessions'),
      current_session: state.user.current_session
    },
    selected_settings_item
  };
};

export default connect(
  ProfileContent,
  mapToProps
);



// WEBPACK FOOTER //
// ./src/containers/middle/SettingsContent.js